"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M13.119 12c0 1.033.507 1.874 1.131 1.874.632 0 1.125-.825 1.125-1.875 0-1.033-.507-1.875-1.131-1.875-.632 0-1.125.825-1.125 1.875M8.78 10.541a.937.937 0 1 0 1.56 1.042.937.937 0 0 0-1.56-1.042"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-7.82 0c0 1.603.89 2.812 2.07 2.812s2.062-1.21 2.062-2.812c0-1.604-.89-2.813-2.07-2.813-1.175 0-2.062 1.21-2.062 2.813M8.257 9.717a1.87 1.87 0 0 0 1.2 3.209L8.7 14.087a.469.469 0 0 0 .786.512l1.596-2.444.003-.007a1.86 1.86 0 0 0-.198-2.413 1.88 1.88 0 0 0-1.325-.55l-.002.002c-.487 0-.954.19-1.303.53"
  })]
}), 'DaysFilled');
